import { render, staticRenderFns } from "./BlogCategoryPicker.vue?vue&type=template&id=99a8c80a&"
import script from "./BlogCategoryPicker.vue?vue&type=script&lang=js&"
export * from "./BlogCategoryPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports